import { Icon16, IconNames16, MenuItem } from '@pinpointhq/thumbtack';
import * as React from 'react';

export function useCsvExport<T = any>() {
  const [data, setData] = React.useState<T[]>([]);
  const [shouldDownload, setShouldDownload] = React.useState(false);

  React.useEffect(() => {
    // this will cause shouldDownload to be true for only one render
    if (shouldDownload) setShouldDownload(false);
  }, [shouldDownload]);

  function handleDownload() {
    setShouldDownload(true);
  }

  const exportMenuItem = (
    <MenuItem icon={<Icon16 icon={IconNames16.DOWNLOAD} />} onClick={handleDownload} text="Export" />
  );

  const determineTotal = (array: { value: number }[]) => {
    return array.reduce((sum, item) => sum + item.value, 0);
  };

  const determinePercentage = (array: { value: number }[], value: number) => {
    const percentage = Math.floor((value / determineTotal(array)) * 1000) / 10;
    return `${percentage}%`;
  };

  return {
    data,
    determinePercentage,
    determineTotal,
    exportMenuItem,
    setData,
    shouldDownload,
  };
}

export default useCsvExport;
